import React, { useState, useContext, useEffect } from "react";
import { PortalContext } from "../../../context/Provider";
import { setPasoMultiTab } from "../../../context/Actions/multiTab/multiTab";
import "./MultiTabV2.css";

const MultiTabV2 = ({ tabs, width, desactivar }) => {
  const { multiTabState, multiTabDispatch } = useContext(PortalContext);
  const [numActivo, setNumActivo] = useState(0);

  const activarPestania = (num, desactivar) => {
    if(desactivar !== undefined){
      if(tabs[num].nombre !== tabs[desactivar].nombre ){
        setPasoMultiTab(num)(multiTabDispatch);
      }
    }else{
      setPasoMultiTab(num)(multiTabDispatch);
    }
  };

  useEffect(() => {
    if (multiTabState.multiTab === undefined) setNumActivo(0);
    else setNumActivo(multiTabState.multiTab.paso);
  }, [multiTabState]);
  
  const divStyle = {
    width: width,
  };
  return (
    <React.Fragment>
      <div className="contenedor-multitab bgc-grey95" style={divStyle}>
        {Array.isArray(tabs) &&
          tabs.length > 0 &&
          tabs.map((item, index) => {
            return (
              <div
                className={`pestania  ${
                  numActivo === index ? "bgc-latex10" : "usarHover"
                }`}
                onClick={() => activarPestania(index, desactivar)}
                key={index}
              >
                {numActivo === index && (
                  <div className="flecha bgc-latex10"></div>
                )}
                <div className="contTitulo">
                  <h2
                    className={`m-0 rb18m textCenter ${
                      numActivo === index ? "c-white" : "c-black10"
                    } ${
                      item.nombre === "Datos personales" ? "tituloMobileV2" : ""
                    }`}
                  >
                    {item.nombre}
                  </h2>
                </div>
              </div>
            );
          })}
      </div>
      {Array.isArray(tabs) &&
        tabs.length > 0 &&
        tabs.map((item, index) => {
          return (
            numActivo === index &&
            React.createElement(
              require(`../` + item.carpeta + `/` + item.componente).default,
              item.params
            )
          );
        })}
    </React.Fragment>
  );
};
export default MultiTabV2;
